import axios from 'axios';
import config from '../../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../../core/modules/common/tools/URLTools';

const apiFetchPredesImpcCodeUsageNonComplianceSummary = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getPredesImpcCodeUsageNonComplianceSummary',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchPredesImpcCodeUsageNonComplianceSummary;
